"use client";

import { InputHTMLAttributes, forwardRef } from "react";
import { cn } from "../../lib/utils";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, label, error, helperText, ...props }, ref) => {
    return (
      <div className="w-full">
        {label && (
          <label className="block text-[14px] font-semibold text-gray-900 mb-2">
            {label}
          </label>
        )}
        <input
          ref={ref}
          className={cn(
            "w-full h-12 px-4 rounded-[12px] border transition-all duration-200 focus:outline-none placeholder:text-[#B5AFCF]",
            "focus:ring-2 focus:ring-[#7A56E8]/18",
            "disabled:bg-gray-50 disabled:text-gray-500 disabled:cursor-not-allowed",
            error
              ? "border-red-400 focus:border-red-500 focus:ring-red-500/18"
              : "border-[#D9DCE5] focus:border-[#7A56E8]",
            className
          )}
          {...props}
        />
        {error && (
          <p className="mt-1.5 text-[13px] text-red-600">{error}</p>
        )}
        {helperText && !error && (
          <p className="mt-1.5 text-[13px] text-[#8E8E93]">{helperText}</p>
        )}
      </div>
    );
  }
);

Input.displayName = "Input";
